export const categories = [
  { slug: 'rexue', name: '热血战斗', count: 328, icon: 'ri-fire-line' },
  { slug: 'lianai', name: '恋爱甜宠', count: 456, icon: 'ri-heart-line' },
  { slug: 'xuanyi', name: '悬疑惊悚', count: 187, icon: 'ri-search-eye-line' },
  { slug: 'qihuan', name: '奇幻冒险', count: 293, icon: 'ri-magic-line' },
  { slug: 'xiju', name: '搞笑日常', count: 215, icon: 'ri-emotion-laugh-line' },
  { slug: 'dushi', name: '都市职场', count: 164, icon: 'ri-building-line' },
];

export const featuredComics = [
  {
    id: '1',
    slug: 'jiansheng-jianghu',
    title: '剑圣江湖',
    author: '金明秀',
    artist: '朴正熙',
    category: '热血战斗',
    rating: 9.7,
    chapters: 89,
    status: '已完结',
    description: '少年林风自幼习剑，为寻找失踪的师父踏入江湖纷争。在刀光剑影中成长，终成一代剑圣。纵横武林，剑气如虹，这是一个关于传承与守护的传奇故事。',
    updateInfo: '全89话 · 已完结',
    isHot: true,
    isNew: false,
  },
  {
    id: '2',
    slug: 'milian-xingkong',
    title: '蜜恋星空',
    author: '崔恩熙',
    artist: '李秀雅',
    category: '恋爱甜宠',
    rating: 9.5,
    chapters: 56,
    status: '连载中',
    description: '天文系学霸遇上校园男神，星空下的浪漫爱情故事。从相遇到相知，甜蜜指数爆表。每一个夜晚的天文观测，都变成了一场浪漫的约会。',
    updateInfo: '更新至56话 · 每周五更新',
    isHot: true,
    isNew: false,
  },
  {
    id: '3',
    slug: 'anying-chengbao',
    title: '暗影城堡',
    author: '韩志勋',
    artist: '姜东元',
    category: '悬疑惊悚',
    rating: 9.3,
    chapters: 42,
    status: '连载中',
    description: '古老城堡中接连发生离奇事件，侦探朴镇宇深入调查，揭开百年前的惊世秘密。每一条线索都指向一个更深的阴谋，真相令人不寒而栗。',
    updateInfo: '更新至42话 · 每周三更新',
    isHot: true,
    isNew: false,
  },
  {
    id: '4',
    slug: 'moshi-yongzhe',
    title: '末世勇者',
    author: '赵成宇',
    artist: '孙泰英',
    category: '奇幻冒险',
    rating: 9.6,
    chapters: 120,
    status: '已完结',
    description: '末日降临，异能觉醒。普通大学生觉醒雷霆之力，带领人类在废土中重建文明。废土之上，勇者无畏，这是一部关于希望与救赎的史诗。',
    updateInfo: '全120话 · 已完结',
    isHot: false,
    isNew: false,
  },
  {
    id: '5',
    slug: 'xingfu-canting',
    title: '幸福餐厅',
    author: '张美兰',
    artist: '刘胜元',
    category: '搞笑日常',
    rating: 9.1,
    chapters: 34,
    status: '连载中',
    description: '一家隐藏在小巷深处的神秘餐厅，每位食客都有自己独特的故事。温暖治愈的美食日常，让你在忙碌的生活中找到片刻的宁静与幸福。',
    updateInfo: '更新至34话 · 每周二更新',
    isHot: false,
    isNew: true,
  },
  {
    id: '6',
    slug: 'jinfu-zongcai',
    title: '金服总裁',
    author: '朴敏俊',
    artist: '郑秀晶',
    category: '都市职场',
    rating: 9.4,
    chapters: 67,
    status: '连载中',
    description: '金融街最年轻的CEO，白天运筹帷幄，夜晚却有着不为人知的秘密身份。商战与情感交织，看霸道总裁如何玩转职场与情场。',
    updateInfo: '更新至67话 · 每周四更新',
    isHot: false,
    isNew: true,
  },
  {
    id: '7',
    slug: 'wudao-zhi-zun',
    title: '武道至尊',
    author: '李泰浩',
    artist: '韩在石',
    category: '热血战斗',
    rating: 9.2,
    chapters: 156,
    status: '连载中',
    description: '废材少年偶得上古武道传承，从此踏上逆天改命之路。拳破苍穹，脚踏九天，终成一代武道至尊。',
    updateInfo: '更新至156话 · 每周一更新',
    isHot: true,
    isNew: false,
  },
  {
    id: '8',
    slug: 'shenquan-wudi',
    title: '神拳无敌',
    author: '郑宇成',
    artist: '金钟国',
    category: '热血战斗',
    rating: 9.0,
    chapters: 78,
    status: '连载中',
    description: '地下拳王重返都市，一双铁拳打遍天下无敌手。热血格斗，拳拳到肉，燃爆你的每一个细胞。',
    updateInfo: '更新至78话 · 每周六更新',
    isHot: false,
    isNew: false,
  },
  {
    id: '9',
    slug: 'yinghua-shuxia',
    title: '樱花树下',
    author: '金素妍',
    artist: '金素妍',
    category: '恋爱甜宠',
    rating: 9.3,
    chapters: 45,
    status: '连载中',
    description: '春天的樱花树下，她遇到了他。一个是内向安静的图书管理员，一个是阳光开朗的摄影师，一段关于相遇与错过的纯爱故事。',
    updateInfo: '更新至45话 · 每周三更新',
    isHot: false,
    isNew: true,
  },
  {
    id: '10',
    slug: 'mimi-huayuan',
    title: '秘密花园',
    author: '尹恩惠',
    artist: '崔秀英',
    category: '恋爱甜宠',
    rating: 9.6,
    chapters: 112,
    status: '已完结',
    description: '灵魂互换的奇幻爱情故事，霸道总裁与特技女演员之间的爆笑罗曼史。当身份互换，爱情也悄悄降临。',
    updateInfo: '全112话 · 已完结',
    isHot: true,
    isNew: false,
  },
  {
    id: '11',
    slug: 'diqi-ceng',
    title: '第7层',
    author: '金秀贤',
    artist: '金秀贤',
    category: '悬疑惊悚',
    rating: 9.4,
    chapters: 38,
    status: '连载中',
    description: '一栋神秘公寓的第7层，每晚都会传出诡异的声响。搬进这层的新住户，逐渐发现了这栋楼隐藏的恐怖真相。',
    updateInfo: '更新至38话 · 每周四更新',
    isHot: false,
    isNew: false,
  },
  {
    id: '12',
    slug: 'wuye-zhuizong',
    title: '午夜追踪',
    author: '张东健',
    artist: '李秉宪',
    category: '悬疑惊悚',
    rating: 9.1,
    chapters: 55,
    status: '连载中',
    description: '连续失踪案的背后，隐藏着一个跨越十年的惊天阴谋。刑警与记者联手追踪真相，一步步走向深渊。',
    updateInfo: '更新至55话 · 每周五更新',
    isHot: false,
    isNew: false,
  },
  {
    id: '13',
    slug: 'long-zhi-gu',
    title: '龙之谷',
    author: '朴宝剑',
    artist: '宋仲基',
    category: '奇幻冒险',
    rating: 9.5,
    chapters: 88,
    status: '连载中',
    description: '少年冒险家误入龙之谷，与远古龙族签订契约，共同对抗黑暗势力的入侵。龙与人的羁绊，一段宏大的奇幻冒险。',
    updateInfo: '更新至88话 · 每周二更新',
    isHot: true,
    isNew: false,
  },
  {
    id: '14',
    slug: 'mofa-jiyuan',
    title: '魔法纪元',
    author: '金泰亨',
    artist: '田柾国',
    category: '奇幻冒险',
    rating: 9.0,
    chapters: 63,
    status: '连载中',
    description: '在魔法与现代科技共存的世界里，一名普通高中生意外觉醒了失传的古代魔法，被卷入魔法界的权力斗争之中。',
    updateInfo: '更新至63话 · 每周日更新',
    isHot: false,
    isNew: true,
  },
  {
    id: '15',
    slug: 'linjia-xiaomei',
    title: '邻家小妹',
    author: '李知恩',
    artist: '裴秀智',
    category: '搞笑日常',
    rating: 8.9,
    chapters: 28,
    status: '连载中',
    description: '隔壁搬来一个古灵精怪的小妹妹，从此男主的平静生活一去不复返。爆笑日常，每一话都让你笑到停不下来。',
    updateInfo: '更新至28话 · 每周一更新',
    isHot: false,
    isNew: true,
  },
  {
    id: '16',
    slug: 'feichai-nixi',
    title: '废柴逆袭',
    author: '姜河那',
    artist: '李东旭',
    category: '搞笑日常',
    rating: 9.2,
    chapters: 96,
    status: '已完结',
    description: '人生输家一觉醒来回到高中时代，运用未来的记忆开启疯狂逆袭之路。笑中带泪，燃到爆炸的校园逆袭喜剧。',
    updateInfo: '全96话 · 已完结',
    isHot: true,
    isNew: false,
  },
  {
    id: '17',
    slug: 'shanghai-fuchen',
    title: '商海浮沉',
    author: '宋康昊',
    artist: '宋康昊',
    category: '都市职场',
    rating: 9.3,
    chapters: 52,
    status: '连载中',
    description: '从底层销售做起，在残酷的商海中披荆斩棘。看一个小人物如何一步步爬上商业帝国的顶端。真实职场，燃情励志。',
    updateInfo: '更新至52话 · 每周五更新',
    isHot: false,
    isNew: false,
  },
  {
    id: '18',
    slug: 'zongjian-daren',
    title: '总监大人',
    author: '全智贤',
    artist: '孙艺珍',
    category: '都市职场',
    rating: 9.1,
    chapters: 41,
    status: '连载中',
    description: '广告公司新来的设计总监，才华横溢却脾气古怪。菜鸟实习生在她手下艰难求生的职场成长故事。',
    updateInfo: '更新至41话 · 每周三更新',
    isHot: false,
    isNew: true,
  },
];

export const popularRankings = [
  { rank: 1, title: '剑圣江湖', category: '热血战斗', views: '1280万', slug: 'jiansheng-jianghu' },
  { rank: 2, title: '蜜恋星空', category: '恋爱甜宠', views: '1156万', slug: 'milian-xingkong' },
  { rank: 3, title: '末世勇者', category: '奇幻冒险', views: '1089万', slug: 'moshi-yongzhe' },
  { rank: 4, title: '暗影城堡', category: '悬疑惊悚', views: '967万', slug: 'anying-chengbao' },
  { rank: 5, title: '金服总裁', category: '都市职场', views: '843万', slug: 'jinfu-zongcai' },
  { rank: 6, title: '幸福餐厅', category: '搞笑日常', views: '721万', slug: 'xingfu-canting' },
  { rank: 7, title: '魔法学院', category: '奇幻冒险', views: '689万', slug: 'mofa-xueyuan' },
  { rank: 8, title: '深夜诊所', category: '悬疑惊悚', views: '654万', slug: 'shenye-zhensuo' },
];

export const latestUpdates = [
  { id: '7', title: '魔法学院', chapter: '第89话', time: '2小时前', slug: 'mofa-xueyuan' },
  { id: '8', title: '深夜诊所', chapter: '第45话', time: '3小时前', slug: 'shenye-zhensuo' },
  { id: '2', title: '蜜恋星空', chapter: '第56话', time: '5小时前', slug: 'milian-xingkong' },
  { id: '9', title: '武林至尊', chapter: '第102话', time: '6小时前', slug: 'wulin-zhizun' },
  { id: '10', title: '重生之巅', chapter: '第78话', time: '8小时前', slug: 'chongsheng-zhidian' },
  { id: '6', title: '金服总裁', chapter: '第67话', time: '10小时前', slug: 'jinfu-zongcai' },
];

export const reviews = [
  {
    id: 'r1',
    username: '漫画控小K',
    handle: '@manga_lover_k',
    avatar: 'https://readdy.ai/api/search-image?query=Korean%20young%20man%20anime%20style%20avatar%20portrait%2C%20stylish%20hair%2C%20simple%20dark%20background%2C%20illustration%20style%2C%20clean%20digital%20art%2C%20warm%20lighting%20on%20face%2C%20minimalist%20character%20design&width=80&height=80&seq=avatar-k-01&orientation=squarish',
    content: '虚空韩漫网的阅读体验真的太棒了！下拉式阅读非常流畅，画质清晰，而且正版授权让我看得安心。推荐所有韩漫爱好者都来这里！',
  },
  {
    id: 'r2',
    username: '深夜追漫人',
    handle: '@night_reader',
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20female%20character%20avatar%20portrait%2C%20dark%20hair%2C%20soft%20warm%20tones%2C%20simple%20dark%20background%2C%20digital%20illustration%2C%20korean%20webtoon%20style%2C%20clean%20minimal%20design&width=80&height=80&seq=avatar-nr-02&orientation=squarish',
    content: '每天晚上都要刷一会韩漫才能睡着，这个网站更新速度超快，而且分类很全。悬疑类的推荐"暗影城堡"，剧情太烧脑了！',
  },
  {
    id: 'r3',
    username: '热血少年团',
    handle: '@passion_fighter',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20male%20anime%20character%20avatar%20with%20spiky%20hair%2C%20energetic%20expression%2C%20simple%20dark%20background%2C%20korean%20webtoon%20illustration%20style%2C%20clean%20digital%20portrait%2C%20warm%20highlights&width=80&height=80&seq=avatar-pf-03&orientation=squarish',
    content: '"剑圣江湖"天下第一！这部漫画的武侠世界观太震撼了，画风也超赞。已经追了两年，完结的时候差点哭了。期待作者的新作！',
  },
  {
    id: 'r4',
    username: '甜宠教主',
    handle: '@sweet_master',
    avatar: 'https://readdy.ai/api/search-image?query=Soft%20anime%20style%20female%20avatar%20with%20gentle%20smile%2C%20pink%20hair%2C%20simple%20dark%20background%2C%20korean%20illustration%20style%2C%20clean%20charming%20portrait%2C%20warm%20lighting&width=80&height=80&seq=avatar-sm-04&orientation=squarish',
    content: '恋爱漫画我只在虚空看！"蜜恋星空"的男女主角CP感太强了，每周五更新是我最期待的时刻。画面精美，剧情不拖沓。',
  },
  {
    id: 'r5',
    username: '奇幻探险家',
    handle: '@fantasy_explorer',
    avatar: 'https://readdy.ai/api/search-image?query=Mysterious%20anime%20style%20character%20avatar%20with%20hood%2C%20adventure%20theme%2C%20simple%20dark%20background%2C%20korean%20webtoon%20art%20style%2C%20clean%20digital%20portrait%2C%20subtle%20warm%20tones&width=80&height=80&seq=avatar-fe-05&orientation=squarish',
    content: '虚空韩漫网的奇幻类漫画质量太高了，"末世勇者"的世界观设定简直神作。120话一口气看完，太过瘾了！强烈推荐。',
  },
  {
    id: 'r6',
    username: '漫画评论家',
    handle: '@comic_critic',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20looking%20anime%20style%20character%20with%20glasses%2C%20intellectual%20vibe%2C%20simple%20dark%20background%2C%20korean%20illustration%2C%20clean%20portrait%2C%20warm%20studio%20lighting&width=80&height=80&seq=avatar-cc-06&orientation=squarish',
    content: '作为看了十年韩漫的老读者，虚空韩漫网是我用过最好的平台。正版授权、高清画质、流畅阅读，这才是漫画平台该有的样子。',
  },
];

export const faqs = [
  {
    question: '虚空韩漫网是免费的吗？',
    answer: '虚空韩漫网提供大量免费韩漫内容供读者阅读。部分热门新作提供免费试读章节，让您在体验后再决定是否购买完整内容。我们致力于在尊重版权的同时，为读者提供最优质的阅读服务。',
  },
  {
    question: '什么是下拉式阅读？',
    answer: '下拉式阅读是韩漫特有的阅读方式，专为手机屏幕优化设计。您只需上下滑动屏幕即可流畅阅读，无需翻页。每话漫画以长条形式呈现，画面连贯，阅读体验极佳。虚空韩漫网全面支持下拉式阅读模式。',
  },
  {
    question: '漫画更新频率是怎样的？',
    answer: '虚空韩漫网上的漫画作品根据连载计划定期更新。大部分热门作品保持每周更新一话的节奏，具体更新时间可以在每部作品的详情页查看。部分完结作品可以一次性畅读全部章节。',
  },
  {
    question: '如何在手机上阅读？',
    answer: '虚空韩漫网采用响应式设计，完美适配手机、平板和电脑等多种设备。您可以直接在手机浏览器中打开网站，即可享受流畅的下拉式阅读体验。网站针对移动端进行了深度优化，加载速度快，画质清晰。',
  },
  {
    question: '漫画内容是正版的吗？',
    answer: '是的，虚空韩漫网上的所有漫画内容均已获得正版授权。我们与韩国多家知名漫画平台和出版社建立了合作关系，确保所有内容均在尊重版权的前提下提供给读者。支持正版，就是支持创作者。',
  },
  {
    question: '如何找到我想看的漫画？',
    answer: '您可以通过首页的分类导航浏览不同类型的热门漫画，也可以使用搜索功能直接查找作品名称。我们还设有排行榜、编辑推荐和最新更新等栏目，帮助您发现更多优质韩漫内容。',
  },
];